import { render } from "./payments-playground.vue?vue&type=template&id=7f6c7bb7"
import script from "./payments-playground.vue?vue&type=script&lang=js"
export * from "./payments-playground.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__